import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    partners: [],
    isLoading: false,
    error: null
};

const collectionPartnerSlice = createSlice({
    name: "collectionPartner",
    initialState,
    reducers: {
        setPartners: (state, action) => {
            state.partners = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        addPartner: (state, action) => {
            state.partners.unshift(action.payload);
        },
        updatePartner: (state, action) => {
            const index = state.partners.findIndex(
                p => p._id === action.payload._id
            );
            if (index !== -1) {
                state.partners[index] = action.payload;
            }
        },
        removePartner: (state, action) => {
            state.partners = state.partners.filter(
                p => p._id !== action.payload
            );
        },
        setError: (state, action) => {
            state.error = action.payload;
        }
    }
});

export const {
    setPartners,
    setLoading,
    addPartner,
    updatePartner,
    removePartner,
    setError
} = collectionPartnerSlice.actions;

export const CollectionPartnerReducer = collectionPartnerSlice.reducer;
